import { render, staticRenderFns } from "./cultureDetail.vue?vue&type=template&id=57aa0104&scoped=true&"
import script from "./cultureDetail.vue?vue&type=script&lang=js&"
export * from "./cultureDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa0104",
  null
  
)

export default component.exports